import { Box } from "@material-ui/core";
import * as React from "react";

import { AuthErrorSummary } from "@/components/AuthFeedback";
import { BottomSheet } from "@/components/BottomSheet";
import { CustomButton } from "@/components/Button";

import { useLogout } from "../../hooks/useLogout";
import { SettingItemsProps } from "../../SettingsPage";
import { useSettingsContentStyles } from "../SettingsContent";

export const LogoutTab: React.FC<SettingItemsProps> = ({ onBack }) => {
  const classes = useSettingsContentStyles();
  const { onClickLogout } = useLogout();
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const inFlight = React.useRef(false);
  const confirm = async () => {
    if (inFlight.current) return;
    inFlight.current = true;
    setLoading(true);
    try {
      await onClickLogout();
    } catch (_) {
      setError("ログアウトできませんでした。時間をおいて、もう一度お試しください。");
    } finally {
      inFlight.current = false;
      setLoading(false);
    }
  };
  return (
    <BottomSheet
      open
      title="ログアウトしますか？"
      description="次に開くときは、もう一度ログインが必要です。登録した内容は残ります。"
      onOpen={() => undefined}
      onClose={() => {
        if (!loading) onBack?.();
      }}
      footer={
        <Box className={classes.actions} style={{ marginTop: 0, paddingTop: 0, gap: 8 }}>
          <CustomButton buttonSize="L" disabled={loading} onClick={confirm}>
            {loading ? "ログアウト中…" : "ログアウト"}
          </CustomButton>
          <CustomButton buttonSize="L" tone="text" disabled={loading} onClick={onBack}>
            キャンセル
          </CustomButton>
        </Box>
      }
    >
      <AuthErrorSummary message={error} />
    </BottomSheet>
  );
};
